module.exports = __webpack_public_path__ + "static/media/menu.dce5088d.svg";